import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-managed-teams-only-link',
    imports: [CommonModule],
    templateUrl: './managed-teams-only-link.component.html',
    styleUrls: ['./managed-teams-only-link.component.scss']
})
export class ManagedTeamsOnlyLinkComponent {
  @Input() teamID;
  @Input() text;
  constructor(
    private userService: UserService
  ) {}

  get isTextOnly() {
    return !(this.userService.isManager || this.userService.managedTeams.includes(this.teamID))
  }
}
